module.exports = __webpack_public_path__ + "static/media/rightArrowGreyhound.351108bb.svg";